/** Rhino/Java-совместимый `java.util.Date` для onLoad/listener скриптов в браузере. */
export function installJavaUtilShim(target: Window & typeof globalThis = window): void {
  const w = target as Window & {
    java?: { util?: { Date?: typeof Date } }
    Packages?: { java?: { util?: { Date?: typeof Date } } }
  }
  const utilDate = { Date }
  w.java = { ...(w.java ?? {}), util: { ...(w.java?.util ?? {}), ...utilDate } }
  if (w.Packages) {
    w.Packages.java = { ...(w.Packages.java ?? {}), util: { ...(w.Packages.java?.util ?? {}), ...utilDate } }
  }
}
